module.exports = __webpack_public_path__ + "assets/img/202108-4W.6037f6cb.png";